var app = angular.module("leonardo");

var ContactTypeEditDialog = function($scope, $rootScope, ContactTypeRestService, FormErrorsService, SectorRestService) {
  $scope.isEdit = $scope.ngDialogData.type? true : false;
  $scope.type = angular.copy($scope.ngDialogData.type);
  $scope.sectorRestService = SectorRestService;

  if ($scope.type) {
    var sectors = [];
    angular.forEach($scope.type.sector, function(sector) {
      sectors.push(!isNull(sector.id) ? sector.id : sector);
    });
    $scope.type.sector = sectors;
  }
  else {
    $scope.type = {
      sector : []
    };
  }

  $scope.submit = function() {
    $scope.Form.$setSubmitted();

    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
   
    if ($scope.isEdit) {
      $scope.type.patch(data).then(function () {
        $rootScope.$broadcast('contact-type:changed');
        $scope.closeThisDialog();
      });
    }
    else {
      data.key = data.name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");

      ContactTypeRestService.post(data).then(function (result) {
        ContactTypeRestService.updateCollection(result);
        $rootScope.$broadcast('contact-type:changed');
        $scope.closeThisDialog();
      });
    }
  };

  $scope.getData = function() {
    return {
      name: $scope.type.name,
      sector: $scope.type.sector
    };
  };
};

app.controller('ContactTypeEditDialog', ['$scope', '$rootScope', 'ContactTypeRestService',
  'FormErrorsService', 'SectorRestService', ContactTypeEditDialog]);
